import React from 'react';
import './Eventos.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import EventosData from '../../Components/Admin/EventosData/EventosData';

export default function Eventos() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <EventosData />
                </div>
            </section>
        </div>
    );
}
